export const API_WIRE_SETTINGS_NOT_FOUND_ERROR = 'NOT_FOUND';
